/*
 * @Description: 微信平台数字品牌价值及三维度
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-19 11:27:36
 * @LastEditTime: 2019-09-24 15:33:50
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './p12.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes/ExportFootDes';
import ExportTable from '../../../components/ExportTable/ExportTable';

import {getKolList} from '../../../controller';
import { getSessionQuery, toThousands } from '../../../utils';

class P12 extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      name: '',
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        accountKolList: [],
        accountKolListDb: 0,
        account_count: 0,
        allKolList: [],
        comments: 0,
        ratio: '',
        reposts: 0
      }
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');

    return {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
  }

  getData () {
    const {query, name} = this.props;

    this.setState({
      name: name,
      query: query
    });

    let params = {
      brandName: query.brandName,
      kolName: '',
      timeStart: query.startDate,
      timeEnd: query.statisDate,
      emotion: 0,
      pltform: query.platform,
      report: true,
    }

    if (query.areaIndustry) {
      params.areaIndustry = query.areaIndustry
      params.competingBrands = query.competingBrands
    }
    

    getKolList(params)
      .then(res => {
        const data = typeof res === 'string' ? JSON.parse(res) : res || {}
        this.setState({
          summary: {
            accountKolList: data.accountKolList || [],
            accountKolListDb: data.accountKolListDb,
            account_count: data.account_count,
            allKolList: data.allKolList || [],
            comments: data.comments,
            ratio: data.ratio || 0,
            reposts: data.reposts
          }
        })
      });
  }

  render() {

    const {query, summary, name} = this.state;

    let readCount,commentsCount;
    if (query.platform === 'wb') {
      readCount = '转发数';
      commentsCount = '评论数';
    } else {
      readCount = '阅读数';
      commentsCount = '在看数';
    }

    const column = [
      {name: 'KOL名称', key: 'kolName'},
      {name: '发布日期', key: 'date'},
      {name: '文章标题', key: 'tit', style: {textAlign: 'left'}},
      {name: readCount, key: 'readCount'},
      {name: commentsCount, key: 'commentsCount'},
      {name: '情感倾向', key: 'emotion'}
    ];

    return (
      <div className={s.container}>
        <ExportHeadTitle>{name}平台本周官方KOL</ExportHeadTitle>

        <div>
          <ExportDes>
            本周，{query.brandName}{name}官方账号共计发布 <span style={{color: '#ffd70d', fontWeight: 600, fontSize: '22px'}}>{toThousands(summary.account_count)}</span> 篇与{query.brandName}相关的内容。
            {query.brandName}官方{name}本周发布内容累计DB值为{toThousands(summary.accountKolListDb)}<em>DB</em>，其在{name}平台的贡献率约为{summary.ratio} 。
          </ExportDes>
        </div>

        <div className={s.tableWrapper}>
          <ExportTable 
            column={column} 
            list={
              summary.accountKolList
                .slice(0, summary.accountKolList.length>7 ? 7 : summary.accountKolList.length)
                .map(item => ({
                  emotion: item.brandList.find(item => {
                    return item.name === query.brandName;
                  }).emotion,
                  commentsCount: item.commentsCount,
                  date: item.date,
                  db: item.db,
                  kolName: item.kolName,
                  readCount: item.readCount,
                  tit: item.tit,
                  url: item.url
                }))
          }></ExportTable>
        </div>

        <ExportFootDes
          brandName={query.brandName}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P12);



// WEBPACK FOOTER //
// src/routes/exportPDF/p12/platform.js